/* eslint-disable @nx/enforce-module-boundaries */
import { FC } from 'react';
import * as Styled from './MNavUtilityItem.styles';
import { AIcon } from '@marriott/mi-web-ui-kit';
import { MNavUtilityItemProps } from './MNavUtilityItem.types';
import clsx from 'clsx';

export const MNavUtilityItem: FC<MNavUtilityItemProps> = ({
  icon,
  rightIcon,
  buttonLabel,
  onClick,
  expanded = true,
  alignment = 'top',
  trackLabel,
}) => {
  return (
    <Styled.Wrapper
      className="px-0"
      expanded={expanded}
      onClick={onClick}
      aria-label={buttonLabel}
      alignment={alignment}
      {...(trackLabel && { 'data-track-label': trackLabel })}
    >
      <span className={clsx(!expanded ? 'm-tooltip-right' : '')} data-content={!expanded ? buttonLabel : undefined}>
        {icon && <AIcon aria-hidden="true" size={icon.size} icon={icon.icon} />}
      </span>
      {buttonLabel && expanded && <Styled.ButtonLabel className="t-subtitle-m">{buttonLabel}</Styled.ButtonLabel>}
      {rightIcon && expanded && (
        <Styled.RightIconWrapper>
          <AIcon aria-hidden="true" size={rightIcon.size} icon={rightIcon.icon} />
        </Styled.RightIconWrapper>
      )}
    </Styled.Wrapper>
  );
};
